module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9695.83d97135.jpg";